module.exports = __webpack_public_path__ + "img/cmg-labs-2.c24deb7f.jpg";